import React from 'react';
import PropTypes from 'prop-types';
import './Input.scss';

export default function Input(props) {
  return (
    <div className="form-custom-input">
      <input {...props} />
    </div>
  );
}
